import { hf } from '../theme';

/** Parse `#RGB`, `#RRGGBB`, or `rgba(r,g,b,a)` → `[r,g,b]` 0–255. */
function parseRgb(color: string): [number, number, number] | null {
  const hex = color.trim().match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
  if (hex?.[1]) {
    const raw = hex[1];
    const full =
      raw.length === 3
        ? raw
            .split('')
            .map((c) => `${c}${c}`)
            .join('')
        : raw;
    const n = Number.parseInt(full, 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  const rgba = color.trim().match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
  if (rgba) return [Number(rgba[1]), Number(rgba[2]), Number(rgba[3])];
  return null;
}

function relativeLuminance([r, g, b]: [number, number, number]): number {
  const toLinear = (c: number) => {
    const s = c / 255;
    return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
  };
  return 0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b);
}

/** High-contrast text for a fill — white on dark, navy on light (no outline). */
export function contrastTextColor(background: string): string {
  const rgb = parseRgb(background);
  if (!rgb) return hf.navy900;
  return relativeLuminance(rgb) > 0.45 ? hf.navy900 : hf.white;
}
